import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import ViewImageAndText from '../../components/ViewImageAndText';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { cleanHtml, Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import CkEditorField from '../../components/CkEditorField';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';

const SectionUpdateTextBook = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload();
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const [questions, setQuestion] = useState("");
    const [editId, setEditId] = useState(null);
    const [syllabusList, setSyllabusList] = useState([]);
    const [subjectList, setSubjectList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")

    const initialFormState = {
        q_level: '',
        q_type: '',
        question: '',
        option_a: '',
        option_b: '',
        option_c: '',
        option_d: '',
        ans: '',
        sol: ''
    }

    const initialFilterState = {
        syllabusStructureMasterId: '',
        lessonMasterId: '',
        topicMasterId: '',
        subTopicId: '',
        subTopicName: '',
        subjectMasterId: ''
    }

    const [filter, setFilter] = useState(initialFilterState);
    const [editAns, setEditAns] = useState(initialFormState)
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [questionLevelSort, setQuestionLevelSort] = useState(null);
    const [questionTypeSort, setQuestionTypeSort] = useState(null);
    const [questionSort, setQuestionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["q_level", "q_type", "question", "option_a", "option_b", "option_c", "option_d", "ans"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getQuestionAnswerList();
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
                setQuestion(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(questions, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
            getQuestionAnswerList();
        }
    }, [filter]);

    useEffect(() => {
        setTotalPages(Math.ceil(questions.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > questions.length) {
            endIndex = questions.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(questions.slice(startIndex, endIndex));
    }, [questions, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `/get-section-question-bank?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;
        if (filter.syllabusStructureMasterId) {
            apiUrl += `sectionSyllabusStructureMasterId=${filter.syllabusStructureMasterId}&`;
        }
        if (filter.subjectMasterId) {
            apiUrl += `instituteSubjectMasterId=${filter.subjectMasterId}&`
        }
        if (filter.lessonMasterId) {
            apiUrl += `sectionLessonMasterId=${filter.lessonMasterId}&`;
        }
        if (filter.topicMasterId) {
            apiUrl += `sectionTopicMasterId=${filter.topicMasterId}&`;
        }
        if (filter.subTopicId) {
            apiUrl += `sectionSubTopicMasterId=${filter.subTopicId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getQuestionAnswerList = async () => {
        try {
            const response = await authorizedAxiosSection.get(getApiUrl())
            setQuestion(response.data.data)
            setQuestionLevelSort(null);
            setQuestionTypeSort(null);
            setQuestionSort(null);
        } catch (error) {
            setQuestion([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-section-syllabus-structure?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicId: '',
                subjectMasterId: ''
            }
        })

        const apiUrl2 = `/get-section-syllabus-structure-Wise-section-subjects?id=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicId: '',
            }
        })
        const apiUrl = `/get-section-subject-wise-section-lesson?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${filter.syllabusStructureMasterId}&instituteSubjectMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                topicMasterId: '',
                subTopicId: ''
            }
        })
        const apiUrl = `/get-section-lesson-wise-section-sub-topic?id=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subTopicId: ''
            }
        })
        const apiUrl = `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${filter.syllabusStructureMasterId}&instituteSubjectMasterId=${filter.subjectMasterId}&sectionLessonMasterId=${filter.lessonMasterId}&sectionTopicMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setSubTopicViewtopicList(response.data.result)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setSubTopicViewtopicList([])
            });
    }

    const handleInputChangeFilter = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleInputChange = (e) => {
        setEditAns((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const deleteSubtopic = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-section-question-bank?id=${id}`;
                const response = await authorizedAxiosSection.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, questions.length);
                await getQuestionAnswerList();
                setCurrPage(page);
                setEditAns(initialFormState)

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateSubtopic = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-section-question-bank?id=${editId}`;

            // Clean fields in one go
            const fieldsToClean = ['question', 'option_a', 'option_b', 'option_c', 'option_d', 'sol'];
            const cleanedFields = {};

            fieldsToClean.forEach(field => {
                cleanedFields[field] = cleanHtml(editAns[field] || '');
            });

            const payload = {
                ...editAns,
                ...cleanedFields
            };

            const response = await authorizedAxiosSection.put(apiUrl, payload);
            await getQuestionAnswerList();
            setSaveId(response.data.result.id);
            setEditAns(initialFormState)
            setEditId(null);

            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    const handleCkChange = (fieldName, editor) => {
        const value = editor.getData();
        setEditAns((prev) => ({
            ...prev,
            [fieldName]: value
        }));
    };

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    loader.file.then(async (file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err.response.data.message);
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    useEffect(() => {
        if (questionLevelSort == true || questionLevelSort == false) {
            setQuestionTypeSort(null);
            setQuestionSort(null);
        }
    }, [questionLevelSort])

    useEffect(() => {
        if (questionTypeSort == true || questionTypeSort == false) {
            setQuestionLevelSort(null);
            setQuestionSort(null);
        }
    }, [questionTypeSort])

    useEffect(() => {
        if (questionSort == true || questionSort == false) {
            setQuestionLevelSort(null);
            setQuestionTypeSort(null);
        }
    }, [questionSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>

                            <li className="breadcrumb-item active"><span>Update Text Book Question Bank</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i>Update Text Book Question Bank</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={filter.syllabusStructureMasterId}>
                                                        <option selected value={''}>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.sectionSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={filter.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='lessonMasterId' onChange={handleLessonChange} value={filter.lessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.sectionLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='topicMasterId' onChange={handleTopicChange} value={filter.topicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.sectionTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subTopicId' onChange={handleInputChangeFilter} value={filter.subTopicId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicViewtopicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.sectionSubTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                {!editId && <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setFilter(initialFilterState) }}>Reset</button>
                                                    </div>
                                                </div>}

                                                {editAns.question !== '' && <>
                                                    {/* <div className='row'> */}
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question Level :</label>
                                                        <input required type="text" className="form-control" id="q_level" name='q_level' onChange={handleInputChange} value={editAns.q_level} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question Type :</label>
                                                        <input required type="text" className="form-control" id="q_type" name='q_type' onChange={handleInputChange} value={editAns.q_type} />
                                                    </div>
                                                    {/* </div> */}
                                                    {/* <div className='row'>
                                                        <div className="col-md-12">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question :</label>
                                                            <input required type="text" className="form-control" id="question" name='question' onChange={handleInputChange} value={editAns.question} />
                                                        </div>
                                                    </div> */}
                                                    <CkEditorField label="Question" name="question" value={editAns.question} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className='row'> */}
                                                    {/* <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option A :</label>
                                                            <input required type="text" className="form-control" id="option_a" name='option_a' onChange={handleInputChange} value={editAns.option_a} />
                                                        </div> */}
                                                    <CkEditorField label="Option A" name="option_a" value={editAns.option_a} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option B :</label>
                                                            <input required type="text" className="form-control" id="option_b" name='option_b' onChange={handleInputChange} value={editAns.option_b} />
                                                        </div> */}
                                                    <CkEditorField label="Option B" name="option_b" value={editAns.option_b} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option C :</label>
                                                            <input required type="text" className="form-control" id="option_c" name='option_c' onChange={handleInputChange} value={editAns.option_c} />
                                                        </div> */}
                                                    <CkEditorField label="Option C" name="option_c" value={editAns.option_c} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option D :</label>
                                                            <input required type="text" className="form-control" id="option_d" name='option_d' onChange={handleInputChange} value={editAns.option_d} />
                                                        </div> */}
                                                    <CkEditorField label="Option D" name="option_d" value={editAns.option_d} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className='row'> */}
                                                    <div className="col-md-12">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Answer :</label>
                                                        <input required type="text" className="form-control" id="ans" name='ans' onChange={handleInputChange} value={editAns.ans} />
                                                    </div>
                                                    {/* <div className="col-md-12">
                                                                <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Solution :</label>
                                                                <input required type="text" className="form-control" id="sol" name='sol' onChange={handleInputChange} value={editAns.sol} />
                                                            </div> */}
                                                    <CkEditorField label="Solution" name="sol" value={editAns.sol} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* </div> */}
                                                    {/* </div> */}
                                                    <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={() => updateSubtopic()} >Save</button>
                                                            <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setEditAns(initialFormState); setEditId(null) }}>Reset</button>
                                                        </div>
                                                    </div>
                                                </>}

                                                {visible && <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                    onIni
                                                >
                                                    <div className="book book-modal">
                                                        <h2 className='table-header-like'>Solution</h2>

                                                        <div className="page" dangerouslySetInnerHTML={{
                                                            __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>`
                                                        }}></div>

                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>}

                                                {visibleImage && (
                                                    <CModal
                                                        visible={visibleImage}
                                                        onClose={() => setVisibleImage(false)}
                                                        aria-labelledby="LiveDemoExampleLabel"
                                                    >
                                                        <div className="book book-modal">
                                                            <div className='table-header-like'>Image</div>
                                                            {modalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: modalImageSrc }}></div>}
                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                                                                Close
                                                            </button>
                                                        </div>
                                                    </CModal>
                                                )}

                                                {filter.subjectMasterId !== "" &&
                                                    <div className="d-grid gap-2 mt-2">
                                                        <div className='tab-content rounded-bottom custom_table custom_table_width'>
                                                            <div className='search_btn_row'>
                                                                <input
                                                                    className="form-control mr-sm-2"
                                                                    type="Search"
                                                                    placeholder="Search"
                                                                    value={searchValue}
                                                                    onChange={handleEmptySearch}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter') {
                                                                            handleSearch();
                                                                        }
                                                                    }}
                                                                />
                                                                <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                            </div>
                                                            <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>
                                                                                Q_Level
                                                                                <SortIcon sortState={questionLevelSort} setSortState={setQuestionLevelSort} setData={setQuestion} setCurrPage={setCurrPage} sortingPath={"q_level"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Q_Type
                                                                                <SortIcon sortState={questionTypeSort} setSortState={setQuestionTypeSort} setData={setQuestion} setCurrPage={setCurrPage} sortingPath={"q_type"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Question
                                                                                <SortIcon sortState={questionSort} setSortState={setQuestionSort} setData={setQuestion} setCurrPage={setCurrPage} sortingPath={"question"} />
                                                                            </th>
                                                                            <th scope="col">Option_a</th>
                                                                            <th scope="col">Option_b </th>
                                                                            <th scope="col">Option_c</th>
                                                                            <th scope="col">Option_d</th>
                                                                            <th scope='col'>Answer</th>
                                                                            <th scope='col'>Solution</th>
                                                                            <th scope='col'>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedData?.length > 0 ?
                                                                                displayedData?.map((question, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                            <td>{question.q_level}</td>
                                                                                            <td>{question.q_type}</td>
                                                                                            {/* <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} /> */}
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.question }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_a }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_b }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_c }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_d }} /></td>
                                                                                            <td>{question.ans}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                    setVisible(!visible)
                                                                                                    setModalData(question.sol)
                                                                                                }}><i class="fa fa-eye"></i></button>
                                                                                            </td>
                                                                                            <td>
                                                                                                <button className="btn btn-outline-warning edit_icon" type="button" style={{ marginRight: '5px' }}
                                                                                                    onClick={() => {
                                                                                                        setEditId(question.id);
                                                                                                        setEditAns({
                                                                                                            q_level: question.q_level,
                                                                                                            q_type: question.q_type,
                                                                                                            question: question.question,
                                                                                                            option_a: question.option_a,
                                                                                                            option_b: question.option_b,
                                                                                                            option_c: question.option_c,
                                                                                                            option_d: question.option_d,
                                                                                                            ans: question.ans,
                                                                                                            sol: question.sol
                                                                                                        });
                                                                                                        document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                                    }}
                                                                                                ><i class="fa-light fa-pen-to-square"></i></button>
                                                                                                <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === question.id} onClick={() => deleteSubtopic(question.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questions.length} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionUpdateTextBook;
